import {Trans} from '@lingui/macro';
import React, {FC} from 'react';

import {Handler} from '../../../libs/shared/helpers/src/react/reactHelpers';
import {Button} from '../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {SettingsResourcePagesEnum} from '../../models/url/settingsUrlModel';
import {SettingsBreadcrumbs} from '../common/settingsBreadcrumbs';
import {SettingsHeader} from '../settingsHeader';
import {useCircleNavigateToLink} from './circlesHelpers';

/*
 * Props.
 */

interface CircleEditorHeaderProps {
  isEditing: boolean;
  onDelete?: Handler;
}

/*
 * Component.
 */

export const CircleEditorHeader: FC<CircleEditorHeaderProps> = (props) => {
  const {isEditing, onDelete} = props;

  const navigateTo = useCircleNavigateToLink();

  return (
    <SettingsHeader
      topLine={
        <SettingsBreadcrumbs
          topLevelBreadcrumb={{
            label: <Trans id="settings-circles-breadcrumb-title">Groups</Trans>,
            onBreadcrumbClick: () => navigateTo(SettingsResourcePagesEnum.OVERVIEW),
          }}
          breadcrumbs={[]}
        />
      }
      right={
        isEditing && (
          <Button isRounded variant={ButtonVariantsEnum.SECONDARY_DANGER} onClick={onDelete}>
            <Trans id="circle-editor-delete">Delete group</Trans>
          </Button>
        )
      }
    >
      {isEditing ? (
        <Trans id="settings-circles-edit-title">Edit group</Trans>
      ) : (
        <Trans id="settings-circles-new-title">Create group</Trans>
      )}
    </SettingsHeader>
  );
};
